/**
 * @author Vivek.Kumar <vivek.kumar@314ecorp.com>
 * @description component to ViewPortBlocker
 */
import { useEffect } from 'react';
import { Layout, Result } from 'antd';
import { BrowserRouterProps } from 'react-router-dom';

import { RESULT_TYPES } from 'components/widgets/AppResult';
import { removeElementFromDom } from 'utils/app';
import { MINIMUM_DESKTOP_VIEWPORT_WIDTH } from '@veritable/common/constants';

/**
 * ViewPortBlocker
 * @description component to handle errors
 */
const ViewPortBlocker: React.FC<BrowserRouterProps> = (props) => {
	const isMobile = globalThis.innerWidth < MINIMUM_DESKTOP_VIEWPORT_WIDTH;

	useEffect(() => {
		if (isMobile) {
			removeElementFromDom();
		}
	}, [isMobile]);

	if (isMobile) {
		return (
			<Layout>
				<Layout.Content className='flex h-screen items-center justify-center'>
					<Result {...RESULT_TYPES.viewPortBlocker} />
				</Layout.Content>
			</Layout>
		);
	}

	return <>{props.children}</>;
};

export default ViewPortBlocker;
